import { forwardRef } from 'react'
import * as Styled from './styled'
import { IProps } from './types'

const Button_ = forwardRef<HTMLButtonElement, IProps>(
  (
    {
      children,
      text = 'Button',
      type = 'primary',
      isDisabled,
      isLarge = false,
      isLoading = false,
      hugePadding = false,
      onClick,
      className
    },
    ref
  ) => {
    return (
      <Styled.ButtonWrapper
        ref={ref}
        onClick={onClick}
        $isDisabled={isDisabled}
        $type={type}
        $isLarge={isLarge}
        $hugePadding={hugePadding}
        $isLoading={isLoading}
        className={className}
        disabled={isDisabled}
      >
        {isLoading ? <Styled.LoadingDots /> : children || text}
      </Styled.ButtonWrapper>
    )
  }
)

Button_.displayName = 'Button_'

export default Button_
